import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { ROUTES } from '@/constants/routes';

import { useAuthStore } from '../stores/useAuthStore';

export function useSignout() {
    const queryClient = useQueryClient();
    const { resetAuthState } = useAuthStore();

    const signout = useCallback(async (): Promise<void> => {
        await queryClient.invalidateQueries({ refetchType: 'none' });
        queryClient.removeQueries();
        resetAuthState();

        window.location.href = ROUTES.login.route;
    }, [queryClient, resetAuthState]);

    return { signout };
}
